<script setup>
/* eslint-disable no-unused-vars */
/* global defineProps, defineEmits */
import { onMounted, watch } from "vue";


const props = defineProps({
  callUpdateAtInit: {
    type: Boolean,
    default: true
  },
  callUpdateAtWatch: {
    type: Boolean,
    default: false
  },
  value: null,
  type: {
    type: String,
    default: 'text'
  },
  placeholder: String,
  param: {
    type: String,
    default: 'input'
  },
  id: {
    type: String
  },
  label: String,
  rules: {
    type: Object,
    default: null
  },
  validate: Boolean,
  autofill: {
    type: Boolean,
    default: true
  },
  icon: String,
  readonly: Boolean,
  colorLabel: {
    type: String,
    default: 'blue-grey-bg'
    // default: 'shared-input-label-black'
  },
  colorInput: {
    type: String,
    // default: 'blue-grey-bg'
    default: 'black'
  },
  disabled: {
    type: Boolean,
    default: false
  },
  class_div_col_label: {
    type: String,
    default: 'col-md-4'
  },
  class_div_col_input: {
    type: String,
    default: 'col-md-8'
  },
  errorValidation: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(["change", "focus", "blur"]);

function updateSelf(value) {
  if (props.type === 'number') {
    value = parseInt(value);
  }
  emit('change', value);
  setTimeout(() => {
    // this.$validator.validate();
  }, 500);
}

function focus() {
  emit('focus');
}

function blur() {
  emit('blur');
}

function change() {
  emit('change');
}

watch(() => props.value, (value) => {
  if (props.callUpdateAtWatch) updateSelf(value);
});

onMounted(() => {
  if (props.callUpdateAtInit) updateSelf(props.value);
});
</script>

<template>
  <div class="form-item">
    <div class="row">
      <div
        v-if="label"
        :class="class_div_col_label"
        class="title"
      >
        <label
          v-if="label"
          :class="colorLabel"
          :for="param"
        >{{ label }}</label>
      </div>
      <div
        :class="class_div_col_input"
        class="class-input"
      >
        <!--      <div class="class-input" :class="{'col-md-8': label, 'col-md-12': !label}">-->
        <input
          :id="id ? id : param"
          :ref="param"
          :type="type"
          :name="param"
          :value="value"
          :readonly="readonly"
          :class="[colorInput, validate && errors.has(param) ? 'is-invalid' : '', errorValidation ? 'error-validation' : '']"
          :data-vv-as="label ? label : ''"
          :autocomplete="'off'"
          :placeholder="placeholder ? placeholder : ''"
          :disabled="disabled"
          @input="updateSelf($event.target.value)"
          @focus="focus"
          @blur="blur"
        >
      </div>

      <font-awesome-icon
        v-if="icon"
        class="icon"
        :icon="icon"
      />
      <div
        v-if="param && validate && errors.has(param)"
        class="animated fadeIn invalid-feedback"
      >
        <font-awesome-icon icon="info-circle" />
        {{ errors.first(param) }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.form-item {
  input {
    border: solid 1px black;
    border-radius: 20px;
    margin-left: 0px;
    padding-left: 15px;

  }

  input[disabled] {
    opacity: 0.6;
    pointer-events: none;

  }

  .class-input {
    .shared-input {
      color: black;
      /*width: 225px;*/
      background: #c9cfd6;

    }
  }

  .title {
    display: inline-flex;
    align-self: center;
    text-align: left;

    .shared-input-color {
      color: black;
      float: left;
      margin: 0;
    }

    .shared-input-report {
      color: black;
      float: right;
      font-size: 21px;
    }

    .shared-input-black {
      color: black;
      float: right;
      font-size: 14px;
    }
  }

  .error-validation {
    border: 2px solid #F56C6C;
  }
}
</style>
